<template>
  <div v-if="show">
    <div class="radish-act-grp">
      批量：
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="showIntoProject(true)">加入项目</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="showEditDialog">修改字段内容</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="showCateDialog('添加')">添加职能模块</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="showCateDialog('删除')">删除职能模块</div>
    </div>
    <div class="radish-btn radish-btn-primary radish-btn-small" @click="mergeRadishes">合并人选</div>
    <div
      v-if="departmentName !== '高管' && departmentName !== '无'"
      class="radish-btn radish-btn-primary radish-btn-small ml20"
      @click="toDepartmentOchart"
    >
      进入部门ochart
    </div>
    <span class="radish-btn radish-btn-primary radish-btn-small" @click="showHeadOrderDialog"> 表头调整 </span>
    <div class="table-box relate-div" v-loading="loading">
      <waterMark :num="20"></waterMark>
      <el-table
        ref="multipleTable"
        v-if="!loading"
        :data="list"
        border
        :height="listHeight"
        tooltip-eff0-ect="dark"
        size="mini"
        highlight-current-row
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        class="no-bg"
        row-class-name="no-bg"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <div v-if="editRowIndex !== scope.$index">
              <span class="drawer-link" @click="edit(scope.$index)">编辑</span>
            </div>
            <div v-else-if="editRowIndex === scope.$index">
              <span class="drawer-link" style="margin-right:5px" @click="cancelEdit">取消</span>
              <span class="drawer-link" @click="confirmEdit">保存</span>
            </div>
          </template>
        </el-table-column>
        <template v-for="item in tableHeads">
          <el-table-column
            v-if="!item.hidden"
            :key="item.label"
            :prop="item.key"
            :label="item.label"
            :width="item.width"
            :resizable="false"
          >
            <template slot-scope="scope">
              <div v-if="editRowIndex !== scope.$index">
                <div v-if="item.key === '姓名'" class="name-cell">
                  <span class="simi-icon" size="mini" @click="getSimi(scope.row)">
                    <i :class="simiClass(scope.row)"></i>
                  </span>
                  <span class="drawer-link" @click="showRadishDetail(scope.row)">{{ scope.row['姓名'] }}</span>
                  <span v-if="!scope.row.手机" style="line-height: 14px;" class="cc-icon">c</span>
                </div>
                <div v-else-if="tagKeys.includes(item.key)">
                  <el-tag
                    v-for="(tag, index) in getTags(scope.row[item.key])"
                    :key="index + 2"
                    type="success"
                    size="mini"
                    style="text-align:center"
                  >
                    {{ tag }}
                  </el-tag>
                </div>
                <div v-else-if="btnKeys.includes(item.key)">
                  <span
                    v-if="item.key === '部门详情' && scope.row.部门"
                    class="drawer-link"
                    @click="showDepartmentDetail(scope.row)"
                    >部门详情</span
                  >
                  <span v-if="item.key === '口碑打分'" class="drawer-link" @click="showScore(scope.row)">口碑打分</span>
                  <span
                    v-if="item.key === '任职经历'"
                    :id="`任职经历${scope.row._id}`"
                    class="drawer-link"
                    @click="showExp(scope.row)"
                    >查看（{{ getExpNum(scope.row) }}）</span
                  >
                </div>
                <template v-else-if="item.key === '手机'">
                  <div v-if="scope.row[item.key] == '***'" @mouseover="getPhone(scope.row._id)">
                    <el-tooltip class="item" effect="dark" :content="scope.row[item.key]" placement="top">
                      <span v-if="scope.row[item.key]" class="company-pointer">***</span>
                    </el-tooltip>
                  </div>
                  <div v-else>{{ scope.row[item.key] }}</div>
                </template>
                <div v-else>
                  <span class="company-pointer">{{ scope.row[item.key] }}</span>
                </div>
              </div>
              <div v-else>
                <!-- 编辑样式 -->
                <div v-if="inputKeys.includes(item.key)">
                  <el-input v-model="editObj[item.key]" size="mini"></el-input>
                </div>
                <div v-else-if="btnKeys.includes(item.key)">
                  <span
                    v-if="item.key === '部门详情' && scope.row.部门"
                    class="drawer-link"
                    @click="alertMsg('部门详情')"
                    >部门详情</span
                  >
                  <span v-if="item.key === '口碑打分'" class="drawer-link" @click="showScore(scope.row)">口碑打分</span>
                  <span
                    v-if="item.key === '任职经历'"
                    :id="`任职经历${scope.row._id}`"
                    class="drawer-link"
                    @click="showExp(scope.row)"
                    >查看（{{ getExpNum(scope.row) }}）</span
                  >
                </div>
                <div v-else>
                  <el-select
                    v-if="objOptions.includes(item.key)"
                    v-model="editObj[item.key]"
                    :multiple="tagKeys.includes(item.key)"
                    filterable
                    size="mini"
                  >
                    <el-option v-for="(v, k) in selectOption[item.key]" :key="v" :label="k" :value="v"> </el-option>
                  </el-select>
                  <el-select
                    v-else
                    v-model="editObj[item.key]"
                    :multiple="tagKeys.includes(item.key)"
                    filterable
                    size="mini"
                    @change="val => setSelectOption(val, item.key)"
                  >
                    <el-option v-for="item in selectOption[item.key]" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-pagination
        class="company-pagination"
        :current-page="page"
        :page-sizes="[20, 70, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <!-- 部门备注dialog -->
    <el-dialog title="部门详情" :visible.sync="departmentDialogVisible" :close-on-click-modal="false" :modal="false" width="30%">
      <el-input v-model="departmentRemark" type="textarea" :rows="2" resize="none" placeholder="请输入内容"> </el-input>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="departmentDialogVisible = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="updateDepartmentRemark">确 定</div>
        <!-- <el-button size="mini" @click="departmentDialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="updateDepartmentRemark">确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 任职经历漂浮窗 -->
    <RadishExperiencePopper ref="RadishExperiencePopper"></RadishExperiencePopper>

    <editDialog ref="editDialog" :on-confirm="loadData"></editDialog>
    <cateDialog ref="cateDialog" :on-confirm="loadData"></cateDialog>
    <!-- 选择合并时的主数据 -->
    <mergeRadishDialog ref="mergeRadishDialog" @choose="loadData"></mergeRadishDialog>
    <!-- 表头调整 -->
    <headOrderDialog ref="headOrderDialog"></headOrderDialog>
  </div>
</template>
<script>
import RadishExperiencePopper from '../exportComponent/radish-experience-popper.vue'
import tableHeads from '../../../radish/src/constant/table-heads'
import editDialog from '../../../radish/src/dialog/edit-dialog'
import cateDialog from '../../../radish/src/dialog/cate-dialog'
import mergeRadishDialog from '../baseComponent/merge-radish-dialog'

const { fieldsBasic } = require('../../../radish/src/constant/fields-detail.js')
import headOrderDialog from '../../../radish/src/dialog/head-order-dialog'
export default {
  components: { RadishExperiencePopper, editDialog, cateDialog, mergeRadishDialog, headOrderDialog },
  // props: {
  //   companyName: { type: String, default: '' },
  // },
  data() {
    return {
      companyName: '',
      departmentName: '',
      list: [],
      show: false,
      loading: false,
      dialogBindRadish: false,
      departmentDialogVisible: false,
      bindRadishKeywords: '',
      departmentRemark: '',
      editRowIndex: -1,
      tableHeads: [
        { label: '姓名', key: '姓名', width: '100' },
        { label: '部门', key: '部门', width: '100' },
        { label: '部门详情', key: '部门详情', width: '100' },
        { label: '组别', key: '组别', width: '100' },
        { label: '口碑打分', key: '口碑打分', width: '100' },
        { label: '职能模块', key: '职能模块', width: '140' },
        { label: '任职经历', key: '任职经历', width: '140' },
        { label: '细分职能', key: '细分职能', width: '100' },
        { label: '擅长方向', key: '擅长方向', width: '100' },
        { label: '地域', key: '地域', width: '100' },
        { label: '目前职位', key: '目前职位', width: '100' },
        { label: '职级', key: '职级', width: '100' },
        { label: '业绩', key: '业绩', width: '100' },
        { label: '长期意向', key: '长期意向', width: '100' },
        { label: '手机', key: '手机', width: '100' },
      ],
      inputKeys: ['姓名', '部门', '组别', '目前职位', '手机'],
      selectOption: {
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        地域: fieldsBasic.地域.options,
        职级: fieldsBasic.职级.options,
        业绩: fieldsBasic.业绩.options,
        长期意向: fieldsBasic.长期意向.options,
      },
      objOptions: ['职级', '长期意向'],
      tagKeys: ['职能模块', '细分职能', '擅长方向', '地域'],
      btnKeys: ['部门详情', '口碑打分', '任职经历'],
      query: {},
      search: {
        姓名: '',
        职能模块: [],
        status: '',
      },
      status: [
        { value: '在职', class: 'el-icon-success icon-blue' },
        { value: '新入职', class: 'el-icon-warning icon-red' },
        { value: '离职', class: 'el-icon-error icon-grey' },
      ],
      status2value: { 在职: 2, 新入职: 3, 离职: 4, 未绑定: [0, 1, null] },
      handleDepartmentRadish: '',
      handleRowIndex: -1,
      listHeight: '100px',
      page: 1,
      total: 0,
      pageSize: 100,
      editRowIndex: -1,
      editObj: {},
      handleRow: {},
      isAdmin: false,
      editDialogTableHeads: [],
      multipleSelection: [],
      storageName: 'comDepartList',
    }
  },
  computed: {
    categories() {
      return app.categories
    },
  },
  watch: {
    $route(to, from) {
      this.close()
    },
  },
  async mounted() {
    // this.initHeight()
    // this.initComponentHeight()
    if (!app.categories) {
      await app.getCats()
    }
    if (app.user && app.user.角色 && app.user.角色.includes('管理员')) this.isAdmin = true
    this.selectOption.职能模块 = app.categories.map(catrgory => catrgory.名称)
    const str = app.user.SL权限 || ''
    this.canSeeTel = str.split(';')
    const editTypes = ['细分职能', '擅长方向', '地域', '职级', '业绩', '长期意向', '部门', '组别', '目前职位']
    this.editDialogTableHeads = tableHeads.data().tableHeads.filter(v => editTypes.includes(v.label))
  },
  methods: {
    // 批量加入项目
    showIntoProject(multi) {
      // const rows = this.multipleSelection.filter(val => val.rid)
      const rows = this.multipleSelection
      if (rows.length === 0) {
        return this.$alert('请勾选已绑定的人选', { showClose: false })
      } else {
        const intoProjectRadishes = rows.map(val => ({ _id: val._id }))
        app.root.$refs.radishProDialog.show(intoProjectRadishes, 'intoProject')
      }
    },
    toDepartmentOchart() {
      app.root.$refs.departmentOchart.open({
        department: this.departmentName,
        companyName: this.companyName,
      })
    },
    mergeRadishes() {
      this.$refs.mergeRadishDialog.open(this.multipleSelection)
    },
    isShowTel(category) {
      if (this.isAdmin) {
        return true
      } else {
        let flag = false
        if (Array.isArray(category)) {
          category.forEach(val => {
            if (this.canSeeTel.includes(val)) flag = true
          })
        } else {
          flag = true
        }
        return flag
      }
    },
    open({ companyName, departmentName, search }) {
      this.initComponentHeight()
      this.show = true
      this.search = search
      this.companyName = companyName
      this.departmentName = departmentName
      this.toSearch()
    },
    initComponentHeight() {
      this.$nextTick(() => {
        const parentDom = this.$parent.$el
        const boxDom = parentDom.querySelector('.below')
        const boxHeight = (boxDom && boxDom.offsetHeight) || 500
        this.listHeight = `${boxHeight - (32 + 32 + 6)}px`
      })
    },
    getTags(val) {
      if (typeof val === 'string' && val) return [val]
      else if (Array.isArray(val)) return val.filter(v => v)
      else return []
    },
    async setSelectOption(arr, key) {
      if (key !== '职能模块') return
      let directionArr = []
      arr.forEach(val => {
        const o = app.categories.find(v => v.名称 === val)
        if (o) directionArr = directionArr.concat(o.擅长方向)
      })
      this.selectOption.擅长方向 = directionArr
      let secondArr = []
      arr.forEach(val => {
        const o = app.categories.find(v => v.名称 === val)
        if (o) secondArr = secondArr.concat(o.二级职能)
      })
      this.selectOption.细分职能 = secondArr
    },
    alertMsg(type) {
      if (type === '部门详情') {
        this.$message('非编辑状态才可以操作部门详情')
      }
    },
    edit(index) {
      this.editRowIndex = index
      const row = this.list[index]
      for (const key in row) {
        const val = typeof row[key] === 'object' ? JSON.parse(JSON.stringify(row[key])) : row[key]
        this.$set(this.editObj, key, val)
      }
      this.setSelectOption(this.editObj.职能模块, '职能模块')
    },
    cancelEdit() {
      this.editRowIndex = -1
      this.editObj = {}
    },
    async confirmEdit() {
      const keys = [
        '姓名',
        '部门',
        '组别',
        '职能模块',
        '细分职能',
        '擅长方向',
        '地域',
        '目前职位',
        '职级',
        '业绩',
        '长期意向',
        '手机',
      ]
      const option = {}
      const oldData = this.list[this.editRowIndex]
      const newData = this.editObj
      keys.forEach(key => {
        if (typeof newData[key] === 'object') {
          if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
            option[key] = newData[key]
          }
        } else if (newData[key] !== oldData[key]) option[key] = newData[key]
      })
      if (Object.keys(option).length > 0) {
        const res = await app.service('radish').modifyById({
          _id: oldData._id,
          data: option,
        })
        if (res.status == 'success') {
          Object.keys(option).forEach(key => {
            oldData[key] = newData[key]
          })
          this.$message.success({ duration: 500, message: '修改成功' })
        } else this.$message.error(res.msg)
      }
      this.cancelEdit()
    },
    getExpNum(item) {
      const exp = item.任职经历
      return Array.isArray(exp) ? exp.length : '0'
    },
    async showExp(item) {
      const option = { radishId: item._id, 任职经历: item.任职经历, 姓名: item.姓名 }
      this.$refs.RadishExperiencePopper.open(option)
    },
    showScore(row) {
      app.root.$refs.radishScore.open(row._id)
    },
    simiClass(row) {
      if (row.status == 2) return 'el-icon-success icon-blue'
      else if (row.status == 3) return 'el-icon-warning icon-red'
      else if (row.status == 4) return 'el-icon-error icon-grey'
      else return 'el-icon-question icon-lightred'
    },
    async getSimi(item) {
      if (!item._id) return this.$message('该数据未与人选绑定')
      const copyObj = JSON.parse(JSON.stringify(item))
      copyObj.thirdId = copyObj.个人ID
      delete copyObj.个人ID
      app.root.$refs.simiDialog.show(copyObj)
    },
    showRadishDetail(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts._id}`, '_blank')
    },
    async showDepartmentDetail(row) {
      const result = await window.app.service('company').getDepartmentDetail({
        公司: this.companyName,
        部门: row.部门,
      })
      this.departmentDialogVisible = true
      this.departmentRemark = result.data.部门备注 || ''
      this.handleDepartmentRadish = row
    },
    async updateDepartmentRemark() {
      const row = this.handleDepartmentRadish
      const result = await window.app.service('company').updateDepartmentDetail({
        query: { 公司: this.companyName, 部门: row.部门 },
        data: { 部门备注: this.departmentRemark },
      })
      if (result.status == 200) {
        this.$message('保存成功')
        this.departmentDialogVisible = false
      }
    },
    sortChange(data) {
      if (data.prop === '排名' || data.prop === '签约时间') {
        this.sort[data.prop] = data.order === 'descending' ? -1 : 1
      }
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    trim(val) {
      return val.replace(/(^\s*)|(\s*$)/g, '')
    },
    toSearch() {
      this.page = 1
      const option = {}
      const { status2value } = this
      for (const key in this.search) {
        const val = this.search[key]
        if (typeof val === 'string') {
          if (val !== '') option[key] = this.trim(val)
        } else option[key] = val
      }
      if (option.status && option.status.length !== 0) {
        let arr = []
        option.status.forEach(v => {
          v === '未绑定' ? (arr = arr.concat(status2value[v])) : arr.push(status2value[v])
        })
        option.status = arr
      }
      this.query = option
      this.loadData()
    },
    clearSerch() {
      for (const key in this.search) {
        if (Array.isArray(this.search[key])) this.search[key] = []
        else this.search[key] = ''
      }
      this.query = {}
      this.page = 1
      this.loadData()
    },
    async loadData() {
      const query = Object.assign(
        { query: this.query },
        { companyName: this.companyName, departmentName: this.departmentName },
        {
          paginate: {
            page: this.page,
            pageSize: this.pageSize,
          },
        },
      )
      try {
        this.loading = true
        const { data, page, pageSize, total } = await app.service('company').getDepartmentPersonList(query)
        this.setHiddenCell()
        this.setCellOrder()
        this.loading = false
        this.list = data
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
      } catch (error) {
        this.$message(error.message)
      }
    },
    close() {
      this.show = false
    },
    showEditDialog() {
      if (this.multipleSelection.length === 0) return this.$message('请勾选人员')
      this.$refs.editDialog.show(this.editDialogTableHeads, this.multipleSelection)
    },
    async showCateDialog(type) {
      if (this.multipleSelection.length === 0) return this.$message('请勾选人员')
      const ids = this.multipleSelection.map(v => v._id)
      this.$refs.cateDialog.show(type, app.categories, ids)
    },
    async getPhone(id) {
      const res = await app.service('radish').simpleFetch({ _id: id, fields: { 手机: 1 } })
      if (res.status == 'success') {
        this.list.forEach(rad => {
          if (rad._id == id) {
            rad.手机 = res.data.手机
          }
        })
      }
    },
    showHeadOrderDialog() {
      const heads = this.tableHeads.map(head => {
        return { label: head.label, visible: !head.hidden }
      })
      this.$refs.headOrderDialog.show({
        heads,
        storageName: this.storageName,
        onConfirm: () => {
          this.loadData()
        },
      })
    },
    setHiddenCell() {
      const heads = localStorage[this.storageName]
      if (heads) {
        const cells = JSON.parse(heads)
        const tmp = this.tableHeads.map(h => {
          if (cells[h.label]) {
            h.hidden = cells[h.label]
          } else {
            h.hidden = false
          }
          return h
        })
        this.tableHeads = tmp
      }
    },
    setCellOrder: async function() {
      const headSort = localStorage[`${this.storageName}_sort`]
      if (headSort) {
        const cellSort = JSON.parse(headSort)
        const tmp = this.tableHeads.sort((a, b) => {
          const labelA = a.label
          const labelB = b.label
          if (cellSort[labelA] > cellSort[labelB]) {
            return 1
          } else {
            return -1
          }
        })
        this.tableHeads = tmp
      }
    },
  },
}
</script>
<style scoped>
.ml20 {
  margin-left: 20px;
}
ul {
  padding: 0;
  overflow: hidden;
  list-style: none;
}
.search-box {
  padding: 10px 20px 10px 20px;
  margin: 0 0 5px;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.search-box span {
  display: inline-block;
}

.search-box li {
  max-width: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  margin: 5px;
}

.search-box li span {
  width: 60px;
}
.company-pointer {
  cursor: pointer;
}
.name-cell {
  position: relative;
  padding-left: 12px;
}
.list-box {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 30;
  padding-bottom: 10px;
  width: 100vw;
  background-color: #fff;
}
</style>
